import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import NewAnalyseRisques from "../../components/AnalyseRisques/ActionsGroup/NewAnalyseRisques";
import ValidatedAnalyseRisques from "../../components/AnalyseRisques/ActionsGroup/ValidatedAnalyseRisques";
import AnalyseRisquesInError from "../../components/AnalyseRisques/ActionsGroup/AnalyseRisquesInError";
import ValidatedSpp from "../../components/AnalyseRisques/ActionsGroup/ValidatedSpp";

class AnalyseRisquesActionsForm extends Component {
    render() {
        let status = this.props.analyseRisques.header.status;

        if (status === "ra_draft" || status === "spp_draft") {
            return <NewAnalyseRisques />;
        } else if (status === "ra_error" || status === "spp_error") {
            return <AnalyseRisquesInError />;
        } else if (status === "ra_validated") {
            return <ValidatedAnalyseRisques />;
        } else if (status === "spp_validated" || status === "spp_cancelled" || status === "spp_closed") {
            return <ValidatedSpp />;
        } else {
            return <div />;
        }
    }
}

const mapStateToProps = (state) => {
    return {
        analyseRisques: state.analyseRisques,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(AnalyseRisquesActionsForm);
